<template>
	<div style="display: flex;">
		<div class="midlle">
			<div class="midller-top">
				<div class="top-item">
					<div class="header">
						<div>
							{{userInfo.level <= 1 ? '普通用户' : '核心用户'}}
						</div>
						<div v-if="userInfo.authentication.school_data == 2"
							style="width: 100px;height: 27px;background: #0052D9;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 27px;">
							学校已认证
						</div>
						<div v-if="userInfo.authentication.company_data == 2"
							style="width: 100px;height: 27px;background: #0052D9;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 27px;">
							单位已认证
						</div>
						<div v-if="userInfo.authentication.school_data == 1"
							style="width: 100px;height: 27px;background: orange;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 27px;">
							学校未认证
						</div>
						<div v-if="userInfo.authentication.company_data == 1"
							style="width: 100px;height: 27px;background: orange;font-size: 16px;color: #FFFFFF;text-align: center;line-height: 27px;">
							单位未认证
						</div>
					</div>
					<p v-if="userInfo.authentication.university || userInfo.authentication.company" style="margin-top: 10px; font-size: 14px;
							font-family: PingFang; 
							font-weight: 400;color: orange;"><span
							v-if="userInfo.authentication.university">学校：{{userInfo.authentication.university}} | </span>
						<span v-if="userInfo.authentication.company">单位：{{userInfo.authentication.company}}</span>
					</p>

					<div class="clounm">
						<div class="title">
							<span class="justi">当前特权</span>: <span
								style="font-weight: normal;color: #636363;">{{userInfo.prerogative}}</span>
						</div>
					</div>
					<div class="clounm"  @click="goToTargetPage">
						<div class="title">
							<span class="justi">关注人数</span>: <span
								style="font-weight: normal;color: #636363;">{{userInfo.fens_num}}</span>
						</div>
					</div>
					<!-- <div class="clounm">
						<div class="title">
							<span class="justi">勋章</span>: <span style="font-weight: normal;color: #636363;">伯乐3级</span>
						</div>
					</div> -->
				</div>
				<div class="top-item">
					<div style="margin-top: 0;">
						<span style="font-weight: bold;">积分：</span> <span
							style="font-weight: normal;color: #636363;">永久{{userInfo.score}}&ensp;当日{{userInfo.today_score}}分</span>
					</div>
					<div style="margin-top: 15px;">
						<span style="font-weight: bold;">活跃：</span> <span
							style="font-weight: normal;color: #636363;">{{userInfo.active}}</span>
					</div>
					<div style="margin-top: 15px;">
						<span style="font-weight: bold;">声望：</span> <span
							style="font-weight: normal;color: #636363;">{{userInfo.prestige}}</span>
					</div>
					<div style="margin-top: 15px;">
						<span style="font-weight: bold;">贡献：</span> <span
							style="font-weight: normal;color: #636363;">{{userInfo.contribution}}</span>
					</div>
					<!-- 		<div style="margin-top: 15px;">
						<span style="font-weight: bold;">背书：</span> <span
							style="font-weight: normal;color: #636363;">伯乐3级</span>
					</div> -->
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title" style="margin-bottom: 5px;">
					<div class="line"></div>
					<div style="margin-left: 20px;">激活中的平台活动</div>
				</div>
				<div style="display: flex;justify-content: flex-end;align-items: center;margin-bottom: 5px;">
					<el-select v-model="activeType" id="selectInp" @change="initPlatformActive" placeholder="全部类型">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<div v-if="platformActive.total">
					<el-table :data="platformActive.data" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column label="类型" width="105" :resizable="false">
							<template slot-scope="scope">
								{{checkLb.label}}
							</template>
						</el-table-column>
						<el-table-column label="角色" width="76" :resizable="false">
							<template slot-scope="scope">
								<span> {{userInfo.id == scope.row.user_id ? '甲方' : '乙方'}}</span>

							</template>
						</el-table-column>
						<el-table-column prop="title" label="标题" width="150" :resizable="false">
						</el-table-column>
						<el-table-column label="状态" width="87" :resizable="false">
							<template slot-scope="scope">
								<span v-if="scope.row.status == 1"> 待审核</span>
								<span v-if="scope.row.status == 2"> 公布中</span>
								<span v-if="scope.row.status == 3"> 已投条</span>
								<span v-if="scope.row.status == 4"> 执行中</span>
								<span v-if="scope.row.status == 5"> 已归档</span>
								<span v-if="scope.row.status == 6"> 已存挡</span>
							</template>
						</el-table-column>
						<el-table-column label="当前状态开始时间" width="136" :resizable="false">
							<template slot-scope="scope">
								<p>{{timeConversion(scope.row.updatetime)}}</p>
							</template>
						</el-table-column>
						<el-table-column prop="nickname" label="当前状态用户" width="134" :resizable="false">

						</el-table-column>

						<el-table-column label="查看详情" width="130" :resizable="false">
							<template slot-scope="scope">
								<div class="link" style="color: #0052D9 !important;"
									@click="checkPlatfActive(scope.row)">查看详情</div>
							</template>
						</el-table-column>

					</el-table>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200"></el-empty>
				</div>
				<div style="display: flex;justify-content: flex-end;">
					<div class="loading" v-if="platformActive.current_page < platformActive.last_page"
						@click="loadingMorePlatformActive">
						<img src='../../assets/images/loading.png' alt=""> 加载更多
					</div>
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title">
					<div class="line"></div>
					<div style="margin-left: 20px;">您关注的内容</div>
				</div>
				<div class="table" v-if="followContent.total">
					<div class="table-item" v-for="(item, index) in followContent.data" :key="item.id"
						:style="index % 2 == 0 ? 'background: #FAFAFA;' : ''">
						<div style="display: flex;align-items: center;">
							<img style="width: 18px;height: 16px;" src='../../assets/images/text.png' alt="">
							<span style="margin-left: 15px;">{{ item.title }}</span>
							<span style="margin-left: 50px;color:#0052D9;" @click="$router.push({ path: `/geniusClub/geniusInfo?id=${item.createuserid}` })">
  牛人：{{ item.createusername }}
</span>
						</div>
						<div class="detail" style="cursor: pointer;" @click="goWhichPool(item)">
							查看详情
						</div>
					</div>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200"></el-empty>
				</div>
				<div style="display: flex;justify-content: flex-end;">
					<div class="loading" v-if="followContent.current_page < followContent.last_page"
						@click="loadingMoreFollow">
						<img src='../../assets/images/loading.png' alt=""> 加载更多
					</div>
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title" style="margin-bottom: 5px;">
					<div class="line"></div>
					<div style="margin-left: 20px;">您可能感兴趣</div>
				</div>
				<div v-if="interestList.total">
					<div style="display: flex;justify-content: flex-end;align-items: center;margin-bottom: 5px;">
						<el-select v-model="interestType" id="selectInp" @change="getInterestList" placeholder="全部类型">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<el-table :data="interestList.data" stripe style="width: 100%" border="" @cell-click='cc'>
						<el-table-column prop="type" label="类型" width="140" :resizable="false">
							<template slot-scope="scope">
								<p>{{checkLb2.label}}</p>
							</template>
						</el-table-column>

						<el-table-column prop="title" label="标题" width="185" :resizable="false">
						</el-table-column>

						<el-table-column label="当前状态开始时间" width="170" :resizable="false">
							<template slot-scope="scope">
								<p>{{timeConversion(scope.row.updatetime)}}</p>
							</template>
						</el-table-column>
						<el-table-column prop="user_name" label="当前状态用户" width="170" :resizable="false">

						</el-table-column>

						<el-table-column label="查看详情" width="154" :resizable="false">
							<template slot-scope="scope">
								<div class="link" style="color: #0052D9 !important;" @click="checkInterest(scope.row)">
									查看详情</div>
							</template>
						</el-table-column>

					</el-table>
				</div>
				<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
					<el-empty :image-size="200"></el-empty>
				</div>
				<div style="display: flex;justify-content: flex-end;">
					<div class="loading" v-if="interestList.current_page < interestList.last_page"
						@click="getInterestList(1)">
						<img src='../../assets/images/loading.png' alt=""> 加载更多
					</div>
				</div>
			</div>
			<div class="midlle-body">
				<div class="body-title" style="margin-bottom: 5px;">
					<div class="line"></div>
					<div style="margin-left: 20px;">我的平台活动</div>
				</div>
				<div>
					<div
						style="display:flex;align-items: center;justify-content: space-between;padding: 0 15px;margin-bottom: 5px;">

						<el-radio-group v-model="checkedCities" @change="getAllActiveList">
							<el-radio v-for="city in cities6" :label="city.id" :key="city.id">{{city.name}}</el-radio>
						</el-radio-group>
						<div style="display:flex;align-items: center;">
							
							<el-select v-model="allType" id="selectInp" @change='getAllActiveList' placeholder="请选择">
								<el-option v-for="item in options" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
								
							</el-select>
							
							<!-- <div style="display: flex;align-items: baseline;cursor: pointer;margin-left: 15px;">
								时间<img src="../../assets/images/shaixuan.png" alt="" style="width: 15px;height: 13px;">
							</div> -->
						</div>
					</div>
					<div v-if="allActiveList.total">
						<el-table :data="allActiveList.data" stripe style="width: 100%" border="" @cell-click='cc'>
							<el-table-column label="类型" width="105" :resizable="false">
								<template slot-scope="scope">
									<p>{{checkLb3.label}}</p>
								</template>

							</el-table-column>
							<el-table-column label="类别" width="75" :resizable="false">

								<template slot-scope="scope">
									<div class="pointer">
										<p>{{checkLb4.name}}</p>

									</div>
								</template>
							</el-table-column>
							<el-table-column prop="title" label="标题" width="150" :resizable="false">
							</el-table-column>
							<el-table-column prop="status" label="状态" width="87" :resizable="false">
								<template slot-scope="scope">
									<span v-if="scope.row.status == 1"> 待审核</span>
									<span v-if="scope.row.status == 2"> 公布中</span>
									<span v-if="scope.row.status == 3"> 已投条</span>
									<span v-if="scope.row.status == 4"> 执行中</span>
									<span v-if="scope.row.status == 5"> 已归档</span>
									<span v-if="scope.row.status == 6"> 已存挡</span>
								</template>
							</el-table-column>
							<el-table-column label="当前状态开始时间" width="132" :resizable="false">
								<template slot-scope="scope">
									<p>{{timeConversion(scope.row.updatetime)}}</p>
								</template>
							</el-table-column>
							<el-table-column prop="user_name" label="当前状态用户" width="130" :resizable="false">
							</el-table-column>

							<el-table-column label="查看详情" width="140" :resizable="false">
								<template slot-scope="scope">
									<div class="link" style="color: #0052D9 !important;"
										@click="checkAllActive(scope.row)">查看详情</div>
								</template>
							</el-table-column>

						</el-table>
					</div>
					<div class="body-mid-main" style="display: flex;justify-content: center;" v-else>
						<el-empty :image-size="200"></el-empty>
					</div>
				</div>

				<div style="display: flex;justify-content: flex-end;">
					<div class="loading" v-if="allActiveList.current_page < allActiveList.last_page"
						@click="getAllActiveList(1)">
						<img src='../../assets/images/loading.png' alt=""> 加载更多
					</div>
				</div>
			</div>
		</div>
		<div class="body-right">
			<div @click="dialogVisible = true">
				<img src='../../assets/images/zhifly.png' alt="" style="width: 18px;height: 18px;"><span
					style="width:80px">发布</span>
			</div>
			<div style="background: #18BC9C;" @click="goto(`/userCenter/drafts`)">
				<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;"><span
					style="width:80px">草稿箱</span>
			</div>
			<div style="background: orange;" @click="goto(`/userCenter/banben`)">
				<img src='../../assets/images/caogao.png' alt="" style="width: 19px;height: 19px;"><span
					style="width:80px">版本管理</span>
			</div>
			<div style="background:#0297F8;" @click="dialogVisible2 = true">
				<img src='../../assets/images/dwen.png' alt="" style="width: 19px;height: 19px;"><span
					style="width:80px">求助</span>
			</div>
			<!-- <div style="background:#444C69;" @click="goto(`/userCenter/pthd/myMessage`)">
				<img src='../../assets/images/iicon.png' alt="" style="width: 18px;height: 16px;"><span
					style="width:80px">@我的</span>
			</div> -->
			<div style="background:#E5F2FF; color: black;" @click="goto(`/userCenter/pthd/myMessage`)">
				<img src='../../assets/images/xiaoxxi.png' alt="" style="width: 18px;height: 16px;"><span
					style="width:80px">我的消息</span>
			</div>
		</div>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/projectNeed/releaseNeed`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					项目需求池
				</div>
				<div @click="goto(`/zyTools/createTools`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/solutionDetail/releaseSolution`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/productService/createProductService`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>

		</el-dialog>
		<el-dialog title="请选择栏目" :visible.sync="dialogVisible2" center width="700px" top="40vh" :lock-scroll="false">
			<div style="display:flex;justify-content: space-around;font-size: 18px;color: black;">
				<div @click="goto(`/zyTools/createTools`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					资源工具池
				</div>
				<div @click="goto(`/solutionDetail/createQz`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height: 47px;text-align: center;cursor: pointer;">
					解决方案池
				</div>
				<div @click="goto(`/productService/proCreateQz`)"
					style="width: 140px;height: 47px;background: #F6F6F6;border: 1px solid #E5E5E5;line-height:47px;text-align: center;cursor: pointer;">
					产品服务池
				</div>
			</div>

		</el-dialog>
	</div>
</template>

<script>
	const cityOptions6 = ['发布', '收藏', '点赞'];
	export default {
		data() {
			return {
				dialogVisible: false,
				dialogVisible2: false,
				cities6: [{
					id: 1,
					name: '发布'
				}, {
					id: 2,
					name: '交互'
				}, {
					id: 3,
					name: '收藏'
				}, 
				{
					id: 4,
					name: '点赞'
				}, 
				{
					id: 5,
					name: '转发'
				}, ],
				checkedCities: 1,
				tableData3: [{
					type: '项目课题',
					title: 'AI只能软件开发',
					date: '2016-05-02',
					status: '已公布',
					name: ['王先生,', '王小虎'],
					link: '详情链接',
					id: 1
				}],

				// 下拉框
				// 1项目需求2资源工具池3解决方案4产品服务
				options: [{
					value: 5,
					label: '全部'
				},
				{
					value: 1,
					label: '项目需求'
				}, {
					value: 2,
					label: '资源工具'
				}, {
					value: 3,
					label: '解决方案'
				}, {
					value: 4,
					label: '产品服务'
				}],
				value: '',
				userInfo: {},
				platformActive: [],
				followContent: [],
				interestList: [],
				allActiveList: [],
				followPage: 1,
				platformPage: 1,
				interestPage: 1,
				allActivePage: 1,
				interestType: 1,
				activeType: 1,
				allType: 1
			}
		},
		created() {
			this.platformInfo()
		},
		computed: {
			checkLb() {
				return this.options.find(item => this.activeType == item.value)
			},
			checkLb2() {
				return this.options.find(item => this.interestType == item.value)
			},
			checkLb3() {
				return this.options.find(item => this.allType == item.value)
			},
			checkLb4() {
				return this.cities6.find(item => this.checkedCities == item.id)
			},

		},

		methods: {
			goToTargetPage() {  
			      // 使用Vue Router的$router.push来跳转到指定页面  
			      this.$router.push({ path: '../GeniusClub' }) // 或者使用 path: '/target'  
			},
			goto(url) {
				this.$router.push(url)
			},
			// myPlatformActivity
			goWhichPool(item) {
				// //内容类型：1项目需求，2资源工具求助，3资源工具，4解决方案，5解决方案求助，6产品服务求助，7产品服务 10用户
				console.log(item);
				let url
				switch (item.type) {
					case 1:
						url = `/projectNeedDetail?id=${item.correlation_id}`
						break
					case 2:
						url = `/zyTools/zyQiuzDetail?id=${item.correlation_id}`
						break
					case 3:
						url = `/zyTools?id=${item.correlation_id}`
						break
					case 4:
						url = `/solutionDetail/?id=${item.correlation_id}`
						break
					case 5:
						url = `/solutionDetail/QZdetail?id=${item.correlation_id}`
						break
					case 6:
						url = `/productService/productQZdetail?id=${item.correlation_id}`
						break
					case 7:
						url = `productService?id=${item.correlation_id}`
						break
					case 10:
						url = `/geniusClub/geniusInfo?id=${item.correlation_id}`
						break
				}
				this.$router.push(url)
			},
			checkPlatfActive(row) {
				console.log(row);
				let url
				// 1项目需求2资源工具池3解决方案4产品服务
				switch (this.activeType) {
					case 1:
						url = `/projectNeedDetail?id=${row.id}`
						break
					case 2:
						url = `/zyTools?id=${row.id}`
						break
					case 3:
						url = `/solutionDetail/?id=${row.id}`
						break
					case 4:
						url = `productService?id=${row.id}`
						break
				}
				this.$router.push(url)
			},
			checkInterest(row) {
				console.log(row);
				let url
				// 1项目需求2资源工具池3解决方案4产品服务
				switch (this.interestType) {
					case 1:
						url = `/projectNeedDetail?id=${row.id}`
						break
					case 2:
						url = `/zyTools?id=${row.id}`
						break
					case 3:
						url = `/solutionDetail/?id=${row.id}`
						break
					case 4:
						url = `productService?id=${row.id}`
						break
				}
				this.$router.push(url)
			},
			checkAllActive(row) {
				let url
				// 1项目需求2资源工具池3解决方案4产品服务
				switch (this.activeType) {
					case 1:
						url = `/projectNeedDetail?id=${row.id}`
						break
					case 2:
						url = `/zyTools?id=${row.id}`
						break
					case 3:
						url = `/solutionDetail/?id=${row.id}`
						break
					case 4:
						url = `/productService?id=${row.id}`
						break
				}
				this.$router.push(url)
			},
			async getPlatformActive() {
				// 1项目需求2资源工具池3解决方案4产品服务
				this.showLoading()
				const list = await this.$api.getActivePlatformList({
					type: this.activeType,
					user_id: this.userInfo.id
				})
				this.platformActive = list.data
				const content = await this.$api.getMyFollowContent({
					user_id: this.userInfo.id
				})
				this.followContent = content.msg
				this.hideLoading()
			},
			async getAllActiveList(type) {
				if (type == 1) {
					this.allActivePage++
					const list = await this.$api.myPlatformActivity({
						page: this.allActivePage,
						user_id: this.userInfo.id,
						type: this.allType,
						cate: this.checkedCities
					})
					this.allActiveList.data = this.allActiveList.data.concat(list.data.data)
					this.allActiveList.current_page = list.data.current_page
					this.allActiveList.last_page = list.data.last_page
				} else {
					this.allActivePage = 1
					const list = await this.$api.myPlatformActivity({
						page: this.allActivePage,
						user_id: this.userInfo.id,
						type: this.allType,
						cate: this.checkedCities
					})
					this.allActiveList = list.data
				}
			},
			async getInterestList(type) {
				if (type == 1) {
					this.interestPage++
					const interest = await this.$api.getInterestList({
						page: this.interestPage,
						user_id: this.userInfo.id,
						type: this.interestType
					})
					this.interestList.data = this.interestList.data.concat(interest.data.data)
					this.interestList.current_page = list.data.current_page
					this.interestList.last_page = list.data.last_page
				}else{
					this.interestPage = 1
					const interest = await this.$api.getInterestList({
						page: this.interestPage,
						user_id: this.userInfo.id,
						type: this.interestType
					})
					this.interestList = interest.data
				}
			},
			async loadingMorePlatformActive() {
				if (this.platformActive.current_page < this.platformActive.last_page) {
					this.platformPage++
					const list = await this.$api.getActivePlatformList({
						page: this.platformPage,
						type: this.activeType,
						user_id: this.userInfo.id
					})
					this.platformActive.data = this.platformActive.data.concat(list.data.data)
					this.platformActive.current_page = list.data.current_page
					this.platformActive.last_page = list.data.last_page
				}
			},
			async initPlatformActive() {
				const list = await this.$api.getActivePlatformList({
					type: this.activeType,
					user_id: this.userInfo.id
				})
				this.platformActive = list.data
			},
			async loadingMoreFollow() {
				if (this.followContent.current_page < this.followContent.last_page) {
					this.followPage++
					const content = await this.$api.getMyFollowContent({
						page: this.followPage,
						user_id: this.userInfo.id
					})
					this.followContent.data = this.followContent.data.concat(content.msg.data)
					this.followContent.current_page = content.msg.current_page
					this.followContent.last_page = content.msg.last_page
				}
			},
			async platformInfo() {
				const info = await this.$api.userPlatformInfo()
				console.log(info.data);
				this.userInfo = info.data
				console.log('用户详情：',this.userInfo)
				this.getPlatformActive()
				this.getInterestList()
				this.getAllActiveList()
			},
			handleChange(val) {
				console.log(val);
			},
			cc(row, column, cell, event) {
				// console.log(row, column.label, cell, event);
			},
		}
	}
</script>
<style>
	/* 	.el-radio__label {
		color: black;
	}
	
	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}
	
	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}
	
	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}
	
	.el-radio__inner {
		border-radius: 0;
	}
	
	.el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */
	.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #0052D9;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #0052D9;
		border-color: #0052D9;
	}
</style>
<style scoped lang="less">
	.detail:hover {
		color: #0052D9;
	}

	.body-title {
		color: #0052D9;
		display: flex;
		margin-bottom: 20px;
		font-weight: bold;
		font-size: 18px;

		.line {
			width: 4px;
			height: 22px;
			background: #0052D9;
		}
	}

	.table {
		.table-item {
			align-items: center;
			display: flex;
			padding: 0 20px;
			justify-content: space-between;
			height: 55px;

		}

	}

	.loading {
		cursor: pointer;
		width: 116px;
		height: 40px;
		background: #F6F6F6;
		display: flex;
		align-items: center;
		margin: 10px;
		margin-bottom: 0;
		justify-content: center;
	}

	.body-right {
		&>div {
			cursor: pointer;
			margin-bottom: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: white;
			line-height: 50px;
			width: 200px;
			height: 50px;
			background: #0052D9;

			&>img {
				margin-right: 15px;
			}
		}
	}

	.midlle-body {
		padding-bottom: 10px;

		/deep/.link {
			color: #0052D9;
			cursor: pointer;
			display: flex;
			justify-content: space-around;
		}

		margin-top: 20px;
		padding-top: 20px;
		box-sizing: border-box;
		background: white;
	}

	.midlle {
		width: 860px;
		padding: 0 20px;
		box-sizing: border-box;

		.midller-top {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.top-item {
				.clounm {
					margin-top: 15px;
					display: flex;

					.title {
						font-weight: bold;

						.justi {
							display: inline-block;
							text-align-last: justify;
							text-align: justify;
							width: 65px;
						}
					}
				}

				font-size: 16px;

				.header {
					display: flex;
					justify-content: space-between;
				}

				padding: 20px 0 20px 20px;
				box-sizing: border-box;
				width: 400px;
				height: auto;
				background: #FFFFFF;
			}
		}
	}
</style>